import * as $ from 'jquery';
import 'bootstrap';
import * as moment from 'moment';
import { bookingFormCommon } from './c005-bookingform-common';
import { wcagOptions } from "./wcag";

export class flightSchedulePage {
    private wcag = new wcagOptions();
    private bcommon = new bookingFormCommon();
    /**
	 * @function initSelectize
	 * @param  {any} listItems [description]
	 * @return {any}           [description]
	 * !!! Properly scoped
	 */
    initSelectize(listItems: any): void {
        let _self = this;
        let bcommon = _self.bcommon;

        let $scope: any = $('#flight-schedule--container');
        let $fschFromLoc: any = $scope.find('.fromfschLocation');
        let $fschFromLocInput: any = $scope.find('.ibe-fsch-from--location');
        let $fschToLoc: any = $scope.find('.tofschLocation');
        let $fschToLocInput: any = $scope.find('.ibe-fsch-to--location');
        let $fschtoLocationById: any = $scope.find('#ibeFschToLocation');
        let $returnTripDateSelectorById: any = $scope.find('#returnTripDateSelector');
        let $oneWayTripDateSelectorById: any = $scope.find('#oneWayTripDateSelector');

        $fschFromLocInput.html(listItems);
        $fschFromLocInput.selectize({
            onInitialize: function () {
                _self.wcag.selectizeInputAria($fschFromLocInput[0].selectize);
            },
            onFocus: function () {
                $fschFromLoc.find('.booking-form--title').addClass('input-filled');
                $fschFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
                $fschFromLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                $fschFromLocInput.parent().find('.booking-form--title').removeClass('has-error');
                let $fromLocationChange = $fschFromLocInput.find('option:selected').text();
                if ($fromLocationChange !== '') {
                    $fschFromLocInput[0].selectize.clear();
                }
            },
            onChange: function (value: string) {
                $fschFromLoc.find('.booking-form--title').addClass('input-filled');
                $fschFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
                if (value.length) { // only get new toLocation values if fromLocation val is filled (do nothing if empty value)
                    bcommon.updateAirportOnDListOnFlowChangeNew("flightschedule", value, $fschToLocInput);
                }
                if (value != "") {
                    setTimeout(function () {
                        $fschtoLocationById.find('input[type="select-one"]').focus();
                        $fschToLoc.find('.booking-form--title').addClass('input-filled');
                        $fschToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
                    }, 300);
                }
            },
            onBlur: function () {
                let $fschFromLocationChange = $fschFromLocInput.find('option:selected').text();
                if ($fschFromLocationChange == '') {
                    $fschFromLoc.find('.booking-form--title').removeClass('input-filled');
                    $fschFromLoc.find('.selectize-control.single .selectize-input').removeClass('select-filled');
                } else {
                    $fschFromLoc.find('.booking-form--title').addClass('input-filled');
                    $fschFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
                }
            },
            onLoad: function (data: any) {
                $fschFromLocInput[0].selectize.trigger('blur');
            },
            lockOptgroupOrder: true,
            searchField: ['text'],
            selectOnTab: true,
            render: {
                item: function (item: any, escape: any) {
                    return '<div>' +
                        (item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
                        '</div>';

                },
                option: function (item: any, escape: any) {
                    let pOpen: any = '';
                    let pClose: any = '';
                    let ptag: any = '';
                    let coma: any = ', ';
                    if (screen.width < 768) {
                        pOpen = '<p class = "airportline">';
                        pClose = '</p>';
                        ptag = '<p>';
                        coma = '';
                    }
                    return '<div>' +
                        (item.text ? pOpen + '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + coma + '</span>' +
                            '<span class = "airportcode">' +
                            escape(item.text.split('|')[2]) + '</span>' + pClose + ptag + escape(item.text.split('|')[1]) + pClose : '') +
                        '</div>';
                }
            }
        });

        $fschToLocInput.html(listItems);
        $fschToLocInput.selectize({
            onInitialize: function () {
                _self.wcag.selectizeInputAria($fschToLocInput[0].selectize);
            },
            onFocus: function () {
                $fschToLoc.find('.booking-form--title').addClass('input-filled');
                $fschToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
                $fschToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                $fschToLocInput.parent().find('.booking-form--title').removeClass('has-error');
                let $toLocationChange = $fschToLocInput.find('option:selected').text();
                if ($toLocationChange !== '') {
                    $fschToLocInput[0].selectize.clear();
                }
            },
            onChange: function (value: any) {
                $fschToLoc.find('.booking-form--title').addClass('input-filled');
                $fschToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
                if ($fschFromLocInput.val() === $fschToLocInput.val()) {
                    $fschToLocInput.parent().find('.selectize-control .selectize-input').addClass('has-error');
                    $fschToLocInput.parent().find('.booking-form--title').addClass('has-error');
                }
                else {
                    $fschToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                    $fschToLocInput.parent().find('.booking-form--title').removeClass('has-error');
                }
                if (value != "") {
                    setTimeout(function () {
                        if (!$scope.find('#oneWayTripDateSelector').is(':visible')) {
                            if ($scope.find('#returnTripDateSelector').find('.departureDate').val() == '') {
                                $returnTripDateSelectorById.find('input[name="start"]').focus();
                            }
                        } else {
                            if ($scope.find('#oneWayTripDateSelector').find('.departureDate').val() == '') {
                                $oneWayTripDateSelectorById.find('input[name="start"]').focus();
                            }
                        }
                    }, 200);
                }
            },
            onBlur: function () {
                let $toLocationChange = $fschToLocInput.find('option:selected').text();
                if ($toLocationChange == '') {
                    $fschToLoc.find('.booking-form--title').removeClass('input-filled');
                    $fschToLoc.find('.selectize-control.single .selectize-input').removeClass('select-filled');
                } else {
                    $fschToLoc.find('.booking-form--title').addClass('input-filled');
                    $fschToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
                }
            },
            onLoad: function (data: any) {

            },
            lockOptgroupOrder: true,
            searchField: ['text'],
            selectOnTab: true,
            render: {
                item: function (item: any, escape: any) {
                    return '<div>' +
                        (item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
                        '</div>';
                },
                option: function (item: any, escape: any) {
                    let pOpen: any = '';
                    let pClose: any = '';
                    let ptag: any = '';
                    let coma: any = ', ';
                    if (screen.width < 768) {
                        pOpen = '<p class = "airportline">';
                        pClose = '</p>';
                        ptag = '<p>';
                        coma = '';
                    }
                    return '<div>' +
                        (item.text ? pOpen + '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + coma + '</span>' +
                            '<span class = "airportcode">' +
                            escape(item.text.split('|')[2]) + '</span>' + pClose + ptag + escape(item.text.split('|')[1]) + pClose : '') +
                        '</div>';
                }
            }
        });
        $(".ibe-fsch-from--location").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
    }
    /**
	 * @function calendarComponent
	 * Calendar component for flight schedule	 
	 */
    calendarComponent(): void {
        let $scope: any = $('#flight-schedule--container');
        let _self = this;

        let $ibeNowDate: any = new Date();
        let $ibeTodayDate: any = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate(), 0, 0, 0, 0);
        let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
        let $ibeMaxLimitDate: any = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
        let $calStartDate: any = new Date($scope.find('.departureDate').datepicker('getDate'));
        let $calEndDate: any = new Date($scope.find('.returnDate').datepicker('getDate'));

        let $curDatepickerInst: any;
        let $curDatepickerTitle: string;

        let $tripTypeContainer: any = $scope.find('.trip-type--container');

        let $highlightDays: any = (date: any) => {
            var startDate: any = new Date($scope.find('.departureDate').datepicker('getDate'));
            var endDate: any = new Date($scope.find('.returnDate').datepicker('getDate'));

            var modClasses: string = '';
            var modAltText: string = '';

            if ((startDate <= date) && (date <= endDate)) {
                modClasses += 'ui-state-selected';
                modAltText = 'Trip dates';
            }

            // highlight departure date
            if (Date.parse(startDate) == Date.parse(date)) {
                // console.log('start date match');
                modClasses += ' ' + 'ui-state-departureDate';
                modAltText = 'Departure date';
            }

            // highlight return date
            if (Date.parse(endDate) == Date.parse(date)) {
                // console.log('end date match');
                modClasses += ' ' + 'ui-state-returnDate';
                modAltText = 'Return date';
            }

            // console.log(modClasses);

            return [true, modClasses, modAltText];
        }
        var $ipad_not: any;
        if (navigator.userAgent.match(/iPad/i)) {
            $ipad_not = 1;
        } else {
            $ipad_not = 2;
        }
        // Single trip calendar - return trip
        let $dateFormat: any = 'd M yy',
            $departDate = $scope.find('.returnTrip .departureDate').datepicker({
                showButtonPanel: true,
                closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                minDate: $ibeTodayDate,
                beforeShowDay: $highlightDays,
                dateFormat: 'd M yy',
                maxDate: $ibeMaxLimitDate,
                numberOfMonths: $ipad_not,
                firstDay: 1,
                onClose: function (selectedDate: any) {
                    $scope.find('.returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate != '') ? selectedDate : $ibeNowDate));
                },
                beforeShow: function (ele: any, obj: any) {
                    $scope.find('#ui-datepicker-div').removeClass('multicityTrip');
                    $curDatepickerInst = obj.dpDiv[0];
                    $curDatepickerTitle = ele.dataset.datepickerTitle;
                },
                afterShow: function () {
                    _self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
                }
            })
                .on('change', function () {
                    $returnDate.datepicker('option', 'minDate', getDate(this));
                    let $nextReturnDate: any = $(this).next('.returnDate');
                    if ($nextReturnDate.val() === "") {
                        window.setTimeout($.proxy(function () {
                            $nextReturnDate.focus();
                        }, this), 100);
                    } else {
                        // do stuff
                    }

                }),
            $returnDate = $scope.find('.returnDate').datepicker({
                showButtonPanel: true,
                closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                dateFormat: 'd M yy',
                minDate: $ibeTodayDate,
                maxDate: $ibeMaxLimitDate,
                beforeShowDay: $highlightDays,
                numberOfMonths: $ipad_not,
                firstDay: 1,
                onClose: function (selectedDate: any) {
                    //	$('.returnTrip .departureDate').datepicker("option", "maxDate", selectedDate);
                },
                beforeShow: function (ele: any, obj: any) {
                    $scope.find('#ui-datepicker-div').removeClass('multicityTrip');
                    _self.bcommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
                    $curDatepickerInst = obj.dpDiv[0];
                    $curDatepickerTitle = ele.dataset.datepickerTitle;
                },
                afterShow: function () {
                    _self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
                }
            })


		/**
		 * Parse single date datepicker value from element
		 */
        let getDate: any = ($element: any) => {
            let $getDate: any;
            try {
                $getDate = $.datepicker.parseDate($dateFormat, $element.value);
            } catch (error) {
                //console.error(error);
                $getDate = null;
            }
            return $getDate;
        }
        // Hightlight Datepicker TD colours
        $scope.find('#ui-datepicker-div').on('mouseover', 'td', () => {
            if ($scope.find('.trip-type--container .returnTrip').hasClass('selected') &&
                $scope.find('.departureDate').val()) {
                let _datepicker: any = $(this);
                _datepicker.parent().addClass('finalRow');

                $('.finalRow').prevAll().find('td:not(.ui-datepicker-unselectable)').addClass('highlight');
                _datepicker.prevAll('td:not(.ui-datepicker-unselectable)').addClass('highlight');

                if (_datepicker.parents().eq(3).hasClass('ui-datepicker-group-last')) {
                    $('.ui-datepicker-group-first td:not(.ui-datepicker-unselectable)').addClass('highlight');
                }
            }
        });

        // Single trip calendar - one way trip
        $scope.find('.oneWay-trip').datepicker({
            showButtonPanel: true,
            closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
            minDate: $ibeTodayDate,
            dateFormat: 'd M yy',
            maxDate: $ibeMaxLimitDate,
            numberOfMonths: $ipad_not,
            firstDay: 1,
            beforeShow: function (ele: any, obj: any) {
                $scope.find('#ui-datepicker-div').removeClass('multicityTrip');
                $curDatepickerInst = obj.dpDiv[0];
                $curDatepickerTitle = ele.dataset.datepickerTitle;
            },
            afterShow: function () {
                _self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);

            }

        });
    }
    ibeTripType(): void {
        let $scope: any = $('#flight-schedule--container');
        let returnDate = '';

        $scope.find('.trip-type--container .returnTrip').click(function () {
            $scope.find('.trip-type--container').find('li').removeClass('selected');
            $scope.find('.trip-type--container').find('li.returnTrip').addClass('selected');
            $scope.find('.book-date--selector.returnTrip').show();
            $scope.find('.book-date--selector.oneWayTrip').hide();
            if (returnDate != '') {
                $scope.find('.returnDate').val(returnDate);
            }
        });

        // one way trip click event (desktop)
        $scope.find('.trip-type--container .oneWayTrip').click(function () {
            $scope.find('.trip-type--container').find('li').removeClass('selected');
            $scope.find('.trip-type--container').find('li.oneWayTrip').addClass('selected');
            $scope.find('.book-date--selector.returnTrip').hide();
            $scope.find('.book-date--selector.oneWayTrip').show();
            returnDate = $scope.find('.returnDate').val();
            $scope.find('.returnDate').val('');
        });

    }

    searchHandler(): void {
        let _self = this;
        let $scope: any = $('#flight-schedule--container');
        let $searchBtn: any = $scope.find('.flight-schedule--btn');
        var $data: any = {};
        $searchBtn.on('click', (evt: any) => {
            _self.validateForm($scope, function () {
                let $fromLocation = $scope.find('.ibe-fsch-from--location').val().split('_')[0];
                let $toLocation = $scope.find('.ibe-fsch-to--location').val();
                let $tripType = $scope.find('.trip-type--container li.selected a').attr('data-triptype');
                let $getDepartureDate: any;
                let $tripFlowUrl: any;

                if ($tripType == 'R') {
                    $getDepartureDate = $scope.find('.returnTrip .departureDate').val();
                } else {
                    $getDepartureDate = $scope.find('.oneWayTrip .departureDate').val();
                }

                let $departureDate = moment(new Date($getDepartureDate)).format('YYYYMMDDhhmm');
                let $getReturnDate = $scope.find('.returnDate').val();
                let $returnDate = moment(new Date($getReturnDate)).format('YYYYMMDDhhmm');
                let $oneWayTripLink = $scope.find('.trip-type--container li.oneWayTrip');

                if ($oneWayTripLink.hasClass('selected')) {
                    $returnDate = '';
                } else {
                    if (!$getReturnDate) return;
                }

                $data = {
                    B_DATE: ($departureDate == 'Invalid date' ? '' : $departureDate),
                    B_LOCATION: $fromLocation,
                    E_DATE: ($returnDate == 'Invalid date' ? '' : $returnDate),
                    E_LOCATION: $toLocation,
                    TRIP_TYPE: $tripType
                };
                $tripFlowUrl = $.param($data);
                let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
                _self.redirectToTimeTable($scope, $tripflow_encryptURL);
            });
        });
    }

    redirectToTimeTable($instance: any, $tripflow_encryptURL: any): void {
        let _self = this;
        let bcommon = _self.bcommon;
        var dataParse: any = null;
        bcommon.preloader();
        $.ajax({
            type: 'GET',
            url: $('[data-get-flight-schedule-url]').attr('data-get-flight-schedule-url'),
            data: 'url=' + $tripflow_encryptURL,
            success: function (data: any) {
                if (typeof data === 'string') {
                    dataParse = JSON.parse(data);
                }
                else {
                    dataParse = data;
                }
                if (dataParse != null) {
                    window.location.href = dataParse.url;
                }
            },
            error: function (error: any) {
                bcommon.preloaderClose();
                var _this = this;
                _this.$error = [];
                let $errorValidation = $instance.find('.error-validation').first();
                $errorValidation.show();
                _this.$error.push("Error while submitting form");
                let $validationContainer: any = $errorValidation.find(".validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
                let $validationMessagelist: any = $validationContainer;
                $validationMessagelist.append('<li data-id="' + 0 + '">' + _this.$error.join(', ') + '</li>');
            }
        });
    }

    validateForm($instance: any, callback: any): boolean {
        let formDataValid = true;
        let $errorList: Array<any> = [];
        let $errorValidation = $instance.find('.error-validation').first();
        $errorValidation.show();

        // Validation: empty from location
        let $fschFromLocation: any = $instance.find('.ibe-fsch-from--location');
        if ($fschFromLocation.val() == '') {
            $fschFromLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
            $fschFromLocation.parent().find('.booking-form--title').addClass('has-error');
            let $fschFromLocValidate: any = $fschFromLocation.attr('data-departloc');
            $errorList.push('<strong>' + $fschFromLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $fschFromLocValidate);
            formDataValid = false;
        } else {
            $fschFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
            $fschFromLocation.parent().find('.booking-form--title').removeClass('has-error');
        }

        // Validation: empty to location
        let $fschToLocation: any = $instance.find('.ibe-fsch-to--location');
        if ($fschToLocation.val() == '') {
            $fschToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
            $fschToLocation.parent().find('.booking-form--title').addClass('has-error');
            let $fschToLocValidate: any = $fschToLocation.attr('data-destloc');
            $errorList.push('<strong>' + $fschToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $fschToLocValidate);
            formDataValid = false;
        } else {
            $fschToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
            $fschToLocation.parent().find('.booking-form--title').removeClass('has-error');
        }

        // Validation: from and to location the same
        if ($fschFromLocation.val() === $fschToLocation.val()) {
            $fschToLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
            $fschToLocation.parent().find('.booking-form--title').addClass('has-error');
            formDataValid = false;
            if (!($fschFromLocation.val() == '' || $fschToLocation.val() == '')) {
                let $fschFromToLocValidate: any = $fschToLocation.attr('data-deptlestloc');
                $errorList.push('<strong>' + $fschFromLocation.parent().find('.booking-form--title').text() + ', ' + $fschToLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $fschFromToLocValidate);
            }
        }

        // Validation: IBE One Way Trip Date empty field
        let $oneWayTripEl: any = $instance.find('.trip-type--container .oneWayTrip'),
            $oneWayDepDate: any = $instance.find('.oneWayTrip .departureDate'),
            $returnDepDate: any = $instance.find('.returnTrip .departureDate'),
            $returnRetDate: any = $instance.find('.returnTrip .returnDate');

        if ($oneWayTripEl.hasClass('selected')) {
            if ($oneWayDepDate.val() == '') {
                $oneWayDepDate.parent().parent().addClass('has-error');
                let $travelDateOne: any = $instance.find('.departureDate.oneWay-trip').attr('data-traveldateOne');
                $errorList.push('<strong>' + $oneWayDepDate.parent().find('label.one-dep-title').text() + ':</strong> ' + $travelDateOne);
                formDataValid = false;
            } else {
                $oneWayDepDate.parent().parent().removeClass('has-error');
            }
        } else {
            /** IBE Return Trip Departure Date empty field validation */
            if ($returnDepDate.val() == '') {
                $returnDepDate.parent().parent().parent().addClass('has-error');
                let $travelDate: any = $returnDepDate.attr('data-travelDepdate');
                $errorList.push('<strong>' + $returnDepDate.parent().find('label.dep-title').text() + ':</strong> ' + $travelDate);
                formDataValid = false;
            } else {
                $returnDepDate.parent().parent().parent().removeClass('has-error');
            }
            /** IBE Return Trip Return Date empty field validation */
            if ($returnRetDate.val() == '') {
                $returnRetDate.parent().parent().parent().addClass('has-error');
                let $travelEndDate: any = $instance.find('.returnDate').attr('data-travelRetdate');
                $errorList.push('<strong>' + $returnRetDate.parent().find('label.ret-title').text() + ':</strong> ' + $travelEndDate);
                formDataValid = false;
            } else {
                $returnRetDate.parent().parent().parent().removeClass('has-error');
            }
        }
        let $validationContainer: any = $errorValidation.find(".validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
        let $validationMessagelist: any = $validationContainer;

        for (var i = 0, len = $errorList.length; i < len; i++) {
            $validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
        }

        if (formDataValid) {
            $errorValidation.hide();
        }
        if (formDataValid) {
            // proceed to retrieve input vars (callback fn)
            if (typeof callback === "function") {
                callback();
            }
        } else {
            return false;
        }
    }

}
let scope: Element = document.querySelector('.flight-schedule-widget');
if (scope) {
    try {
        let flightschedulepage = new flightSchedulePage();
        let bookingformcommon = new bookingFormCommon();
        $.when(window['ibeOnDListNew']).done((listData: any) => {
            let listItems: string = bookingformcommon.parseOnDListItemsNew(listData, 'revenue', 'flightschedule');
            flightschedulepage.initSelectize(listItems);
            flightschedulepage.calendarComponent();
            flightschedulepage.ibeTripType();
            flightschedulepage.searchHandler();
        });


    } catch (e) { console.error(e); }
}